import store from '@/store'

const helper = {
  sessionStorageValue(name, defaultValue = null) {
    return sessionStorage.getItem(name) &&
      sessionStorage.getItem(name) !== 'undefined'
      ? JSON.parse(sessionStorage.getItem(name))
      : defaultValue
  },
}
const state = {
  dataVerificationInRegister: helper.sessionStorageValue('dataVerificationInRegister', false),
}
const getters = {
  getDataVerificationInRegister: (state) => state.dataVerificationInRegister,
}
const actions = {
  setDataVerification({ commit }, payload) {
    commit('SET_VERIFICATION_IN_REGISTER', payload)
  },
}
const mutations = {
  SET_VERIFICATION_IN_REGISTER(state, payload) {
    state.dataVerificationInRegister = payload
    sessionStorage.setItem('dataVerificationInRegister', JSON.stringify(payload))
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
